"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BundledAssignmentSerializer = void 0;
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
const dp_http_client_lib_1 = require("@greatmindsorg/dp-http-client-lib");
const date_helper_1 = require("../../helpers/date.helper");
const assignment_serializer_1 = require("./assignment.serializer");
const scoring_settings_serializer_1 = require("./scoring-settings.serializer");
class BundledAssignmentSerializer extends dp_http_client_lib_1.PageableSerializer {
    constructor(assignmentSerializer = new assignment_serializer_1.AssignmentSerializer(), scoringSettingsSerializer = new scoring_settings_serializer_1.ScoringSettingsSerializer()) {
        super();
        this.assignmentSerializer = assignmentSerializer;
        this.scoringSettingsSerializer = scoringSettingsSerializer;
    }
    serializeOne(data) {
        return {
            assignmentId: data.assignmentId,
            contextId: data.contextId,
            assigneeCount: data.assigneeCount,
        };
    }
    serializeClasses(data) {
        if ((0, isEmpty_1.default)(data))
            return [];
        return data.map((eachClass) => {
            const classDetail = {
                schoolId: eachClass.schoolId,
                curriculumId: eachClass.curriculumId,
                contextId: eachClass.contextId,
                assigneeIds: (0, isEmpty_1.default)(eachClass.assigneeIds)
                    ? []
                    : eachClass.assigneeIds,
            };
            return classDetail;
        });
    }
    serializeDetail(data) {
        return {
            bundleId: data.bundleId,
            title: data.title,
            instructions: data.instructions,
            startDate: (0, date_helper_1.toLocalDate)(data.startDate),
            dueDate: (0, date_helper_1.toLocalDate)(data.dueDate),
            classes: this.serializeClasses(data.classes),
            assignmentResources: this.assignmentSerializer.serializeResources(data.assignmentResources),
            scoringSettings: data.scoringSettings
                ? this.scoringSettingsSerializer.serializeOne(data.scoringSettings)
                : null,
        };
    }
}
exports.BundledAssignmentSerializer = BundledAssignmentSerializer;
//# sourceMappingURL=bundled-assignment.serializer.js.map